import defaultBackgroundUrl from '@/assets/img/defaultPersonalHomeBackground.png';
import {getDefaultAIAgentData} from '@/plugins/AIChatPlugin/AigcChat/AIAgent/constants';

export const KEYS = {
    USER: 'user',
    USERS_MAP: 'usersMap',
    SIDEBAR_MENU_TARGET: 'sidebarMenuTarget',
    CUR_REPOSITORY: 'curRepository',
    CUR_REPOSITORY_ERROR: 'curRepositoryError',
    CUR_REPOSITORY_NAME: 'curRepositoryName',
    CUR_PAGE: 'curPage',
    CUR_DOCUMENT: 'curDocument',
    CUR_DOCUMENT_ERROR: 'curDocumentError',
    CUR_DOCUMENTS: 'curDocuments',
    APPROVAL_OPERATE: 'approvalOperate',
    // curRepository在会议模式中的文档列表
    DOCS_IN_MEETING: 'docsInMeeting',
    //
    DOCUMENT_OPERATE: 'documentOperate',
    CREATE_DOCUMENT: 'createDocument',
    CREATE_DIRECTORY: 'createDirectory',
    DELETE_DOCUMENT: 'deleteDocument',
    MOVE_DOCUMENT: 'moveDocument',
    COPY_DOCUMENT: 'copyDocument',
    CONVERTTOCATALOG_DOCUMENT: 'convertToCatalog',
    CONVERTTODOC_DOCUMENT: 'convertToDoc',
    //
    MEMBER_OPERATE: 'memberOperate',
    // query/info 接口数据
    QUERY_INFO: 'queryInfo',
    // 进入历史模式展示的Tab项
    HISTORY_MODE_TAB_VALUE: 'historyModeTabValue',
    // 进入历史记录的版本号
    HISTORY_MODE_VERSION_ID: 'historyModeVersionId',
    //
    DOCUMENT_MODE: 'documentMode',
    // 演示模式
    DEMO_MODE: 'demoMode',
    // 卡片视图
    IS_CARD_VIEW: 'isCardView',
    // 卡片视图
    IS_VIEW_MODIFIED: 'isViewModified',
    // 临时使用（支持卡片视图线上老数据兼容，旧版为千人千面，新版改为作为文档的一个属性），不需要兼容线上老数据后，可删除相关逻辑
    SHOW_SLIDE: 'showSlide',
    // 编辑器实例ref
    EDITOR_REF: 'editorRef',
    // 底部评论实例ref
    COMMENT_EDITOR_REF: 'commentEditorRef',
    EDITOR_DOM_READY: 'editorDomReady',
    SAVECOMMENT_RELOAD: 'saveCommentReload',
    // 记录文档滚动到的位置
    DOCUMENT_POSITION: 'documentPosition',
    DOCUMENT_SAVE_STATUS: 'editorStatus',
    DOCUMENT_WS_STATUS: 'documentWsStatus',
    // 最新的编辑者
    LATEST_EDIT_USER: 'latestEditUser',
    // 左侧目录高度
    SIDEBAR_WIDTH_CHANGE_INFO: 'sidebarWidthChangeInfo',
    IS_WIDE_SCREEN_MODE: 'isWideScreenMode',
    // 新手引导
    NEW_GUIDE: 'newGuide',
    DONE_END_MEETING_GUIDE: 'doneEndMeetingGuide',
    DONE_SETTING_GUIDE: 'doneSettingGuide',
    // 部门知识库
    CUR_DEPARTMENT: 'curDepartment',
    CUR_DEPARTMENT_ERROR: 'curDepartmentError',
    OPEN_DEP_INTRO_DETAIL: 'showDepIntroDetail',
    SIDE_NAR_OPEN: 'sidebarOpen',
    SHOW_CREATE_REPO: 'showCreateRepo',
    SIDE_BAR_DRAG_OPTION: 'sidebarDragOption',
    TEMPLATE: 'template',
    // MARKS: store-keys
    OPEN_SETTING: 'openSetting',
    OPEN_SETTING_TAB: 'openSettingTab',

    IS_STAT_NUM_SHOW: 'isStatNumShow',
    // 文档tab标签
    CUR_DOCUMENT_TAG: 'curDocTagData',
    // 关注状态
    CUR_DOCUMENT_STAR: 'curDocStar',
    // 新版本发布提示
    CUR_DOCUMENT_NEW_VERSION_INFO: 'curDocNewVersionInfo',
    // 协同人列表
    CUR_DOCUMENT_COLLABORATORS: 'curDocCollaborators',
    // 评论数
    CUR_DOCUMENT_COMMENT_COUNT: 'curDocCommentCount',
    // 评论数
    CUR_DOCUMENT_TOKEN: 'curDocTokenData',
    // 文档知识币数量
    CUR_DOCUMENT_KNOWLEDGE_COIN: 'curDocKnowledgeCoin',
    // 当前用户对当前文档是否投币
    CUR_USER_IS_DEPOSIT_CUR_DOCUMENT: 'curUserIsDepositCurDocument',
    // 公开发布文档弹窗
    SHOW_PUBLISH_DOC_DIALOG: 'showPublishDocDialog',
    // 公开发布文档弹窗属性
    PUBLISH_DOC_DIALOG_PROPS: 'publishDocDialogProps',

    // 文档页面
    CUR_MEETING_DOCS: 'curMeetingDocs',
    // 展示保存模版弹窗
    SHOW_SAVE_TPL_DIALOG: 'showSaveTplDialog',
    SHOW_DOC_STAT_DIALOG: 'showDocStatDialog',
    SHOW_EDITOR_CHILDREN: 'showEditorChildren',

    // 发布广场开关状态
    PUBLISH_TO_SQUARE_DATA: 'publishToSquareData',
    ICAFE_RELATED_SHOW: 'iCafeRelatedShowData', // 是否显示 iCafe 关联对话框
    IS_Stat_NUM_SHOW: 'isStatNumShow',
    IS_NEED_REFRESH_ICAFE: 'isNeedRefreshICafe', // 是否需要更新 iCafe 列表

    // 文档引用
    IS_DOC_CITE_SHOW: 'isDocCiteShow',
    // 如流待办冲突列表
    TODO_CONFLICT_LIST: 'todoConflictList',

    // 百科
    IS_BAIKE_HOME: 'isBaikeHome',
    IS_BAIKE_REPO: 'isBaikeRepo',
    IS_BAIKE_ROUTE: 'isBaikeRoute',
    SHOW_OFFICIAL_TAG: 'showOfficialTag',
    // 常用文档
    COMMON_DOCS: 'commonDocs',
    // 读写合一小流量数据
    RW_MODE: 'rwMode',
    // 目录的数据
    // 目录重构了 已经没有documentIndex节点
    // DOCUMENT_INDEX_DATA: 'documentIndexDate',
    PAGE_SECURITY_SETTINGS: 'pageSecuritySettings',
    KU_SECURITY_SETTINGS: 'kuSecuritySettings',
    SHARE_COLLABORATE_GUIDE: 'shareCollaborateGuide',
    // 是否Ku享模式
    IS_KU_SHARE_MODE: 'isKuShareMode',
    KU_SHARE_PARAMS: 'kuShareParams', // 其他Ku享配置
    KU_SHARE_HOST_INFO: 'kuShareHostInfo', // Ku享主持人信息
    KU_SHARE_FULLSCREEN: 'kuShareFullscreen', // Ku享内全屏模式
    // 目录的所有权限
    DIRECTORY_EDIT: 'directoryEdit',
    DIRECTORY_HAS_DATA: 'directoryHasData',
    SO_USER_DATA: 'soUserData',

    // 图片预览相关
    PREVIEW_IMAGE: 'previewImage',
    PREVIEW_IMAG_VISIBLE: 'previewImageVisible',
    PREVIEW_IMAGE_RATIO: 'previewImageRatio',
    PREVIEW_IMAGE_ADAPTION_RATIO: 'previewImageAdaptionRatio',
    PREVIEW_IMAGE_MODE: 'previewImageMode',

    // 顶部栏header宽度适配相关
    HEADER_ADAPTER_DATA: 'headerAdapterData',
    // 文档内容区宽度
    DOC_CONTENT_WIDTH: 'docContentWidth',
    // 邀请成员的时间戳，用于刷新知识本用户展示
    INVITE_MEMBER_TIME: 'inviteMemberTime',
    // 分片应该展示的文档,及其对应的useState
    TREE_RENDER_LIST: 'treeRenderList',
    // 导入文件列表
    IMPORT_FILE_LIST: 'importFileList',
    // 客户端导入文件信息（旧），后续会删去
    CLIENT_IMPORT_FILE_DATA: 'clientImportFileData',
    // 客户端导入文件信息
    CLIENT_TRANSFORM_FILE_DATA: 'clientTransformFileData',
    // 传输的导入文件信息，用于唤起导入文件组件
    UPLOAD_INPUT_OPTIONS: 'uploadInputOptions',
    // 文档核心接口 NEWEST
    DOC_READY: 'docReady',
    // URL上的需要清除的参数
    URL_QUERY: 'urlQuery',
    // 站内通知未读数
    MESSAGE_UNREAD_COUNT: 'messageUnReadCount',
    // 通知优化小流量
    IN_MESSAGE_OPTIMIZE_WHITE_LIST: 'inMessageOptimizeWhiteList',

    // PPT实例对象
    PPT_EDITOR_REF: 'pptEditorRef',
    // 是否显示数据表模板弹窗
    DST_TPL_DIALOG_DATA: 'dstTplDialogData',
    // 数据表 token
    DST_TOKEN: 'dstToken',
    // 创建数据表夹 loading
    CREATE_DST_LOADING: 'createDstLoding',
    // 个人主页
    PERSONAL_HOME_USER_GUID: 'personalHomeUserGuid',
    PERSONAL_HOME_USER_NAME: 'personalHomeUserName',
    PERSONAL_HOME_STAR_HAS_GIVEN: 'personalHomeStarHasGiven',
    PERSONAL_HOME_COIN_INFO: 'personalHomeCoinInfo',
    PERSONAL_HOME_SUB_INFO: 'personalHomeSubInfo',
    PERSONAL_HOME_BG: 'personalHomeBg',
    PERSONAL_HOME_DOC_LIST_TAB_MENU: 'personalHomeDocListTabMenu',
    // AIGC小流量
    IS_OPEN_AIGC: 'isOpenAigc',
    OPEN_AIGC_INFO: 'openAigcInfo',
    // 表格导入弹窗数据
    IMPORT_EXCEL_DIALOG_DATA: 'importExcelDialogData',

    // 目录重构后存储的全局变量
    SIDEBAR_LIST_OBJ: 'sidebarListObj',
    SIDEBAR_TREE_OBJ: 'sidebarTreeObj',

    // AI Agent
    AI_AGENT_DATA: 'AIAgentData',

    // AIGC侧边栏面板
    AI_CHAT_PANEL: 'aiChatPanel',
    // 快捷指令继续聊天的数据
    CONTINUE_CHAT_DATA: 'continueChatData',
    // 快捷指令是否启用
    QUICK_CMD_ENABLE: 'quickCmdEnable',
    // 对外分享弹窗
    SHOW_EXTERNAL_SHARING_DIALOG: 'showExternalSharingDialog',

    // 当前文档内容是否为空
    IS_DOC_EMPTY: 'isDocEmpty',
    // 当前文档内容是否为空，包含空格
    IS_DOC_EMPTY_WITH_SPACE: 'isDocEmptyWithSpace',
    // 是否操作了AI模板
    IS_AI_TEMPLATE_ACTIVE: 'isAiTemplateActive',
    AI_TEMPLATE_LIST: 'aiTemplateList',
    // 是否开启了智能问答
    IS_OPEN_QUESTION_ANSWER: 'isOpenQuestionAnswer',
    // 智能问答初识数据
    QUESTION_ANSWER_SETTINGS: 'questionAnswerSettings',
    // 智能问答是否开启小流量
    IS_OPEN_QUESTION_ANSWER_IN_GRAY: 'isOpenQuestionAnswerInGray',

    // 知识库展示具体权限人数
    MEMBERS_COUNT: 'membersCount',
    // 知识库展示具体权限人数是否开启小流量
    IS_MEMBERS_COUNT_IN_GRAY: 'isMembersCountInGray',
    // 部门知识库可查看权限风险模块的权限
    POWER_RECYCLE_PERMISSION: 'powerRecyclePermission',
    // 知识库权限风险条数
    REPO_PERMISSION_RISK_COUNT: 'repoPermissionRiskCount',
    // 文档视图下，是否显示封面
    IS_SHOW_COVER: 'isShowCover',
    SHOW_DOC_COVER: 'showDocCover',
    SHOW_SLIDE_COVER: 'showSlideCover',
    IS_COVER_APPLIED: 'isCoverApplied',
    KM_HEAD_TIPS_INFO: 'kmHeadTipsInfo',
    // 当前文档的所有卡片点赞信息
    CUR_DOC_CARD_LIKES_INFO: 'curDocCardLikesInfo',
    IS_SHOW_CARD_LIKE_NEWGUID: 'isShowCardLikeNewGuid',
    URL_QUERY_SEARCH: 'urlQuerySearch',
    // 模板库定位数据
    MATERIAL_POS_DATA: 'materialPosData',
    // 更多菜单工具列表
    DROP_MENU_TOOL_LIST: 'dropMenuToolList',
    // 文档字数统计
    DOC_WORD_NUM: 'docWordNum',
    SDK_SHOW_SIDEBAR_TOOLS: 'sdkShowSidebarTools',
    SDK_SHOW_DOCUMENT_TITLE: 'sdkShowDocumentTitle',
    SDK_SHOW_DOCUMENT_COMMENT: 'sdkShowDocumentComment',
    SDK_SHOW_AI_PANEL: 'sdkShowAiPanel',
    // 记录编辑器局部刷新状态，提醒ku享重新绑定滚动事件
    IS_EDITOR_RELOADING: 'isEditorReloading',
    SHOW_POWER_SETTING: 'showPowerSetting',
    SHOW_MEMBER_LIST: 'showMemberList',
    POWER_MODAL: 'powerModal',
    // 保存选中申请管理员
    APPLY_ADMIN_INFO: 'applyAdminInfo',
    DOCUMENT_SHARE_MODAL_VISIBLE: 'documentShareModalVisible',
    // 目录树批量操作-是否开启
    IS_TREE_BATCH_OPERATE: 'isTreeBatchOperate',
    // 目录树批量操作-选中数据
    TREE_SELECTED_OBJ: 'treeSelectedObj',
    // 目录树批量选满状态
    TREE_SELECTED_FULL: 'treeSelectFull',
    // 是否展示侧边栏 - 用于控制左侧边栏刷新
    IS_SHOW_SIDEBAR: 'isShowSidebar',
    // 目录树的文档数据
    TREE_DATA: 'treeData',
    // 对外知识库顶部tips
    EXTERNAL_REPO_TIPS: 'externalRepoTips',
    // 随心搭节点状态存储
    FLEX_BUILDER_STATE: 'flexBuilderState',
};

export const KEYS_DEFAULT_VALUE = {
    [KEYS.IS_BAIKE_REPO]: false,
    [KEYS.DEMO_MODE]: false,
    [KEYS.IS_CARD_VIEW]: false, // true是卡片视图，false是文档视图
    [KEYS.SHOW_SLIDE]: false,
    [KEYS.IS_STAT_NUM_SHOW]: false,
    [KEYS.IS_DOC_CITE_SHOW]: false,
    [KEYS.IS_WIDE_SCREEN_MODE]: true,
    [KEYS.DST_TPL_DIALOG_DATA]: {visible: false},
    [KEYS.DST_TOKEN]: '', // @dst-todo 缓存逻辑暂时注释，后续再做优化 storageUtils.get(DataSheetTokenStorageKey) || ''
    [KEYS.CUR_DOCUMENT_STAR]: null, // 未星标值统一为null
    [KEYS.HISTORY_MODE_TAB_VALUE]: '',
    [KEYS.MESSAGE_UNREAD_COUNT]: {mention: 0, approval: 0, other: 0},
    [KEYS.CREATE_DST_LOADING]: false,
    [KEYS.DOCUMENT_WS_STATUS]: '',
    [KEYS.IS_OPEN_AIGC]: false,
    [KEYS.QUICK_CMD_ENABLE]: false,
    [KEYS.IMPORT_EXCEL_DIALOG_DATA]: {visible: false},
    [KEYS.PERSONAL_HOME_BG]: defaultBackgroundUrl,
    [KEYS.IS_DOC_EMPTY]: false,
    [KEYS.IS_AI_TEMPLATE_ACTIVE]: false,
    [KEYS.AI_TEMPLATE_LIST]: [],
    [KEYS.AI_AGENT_DATA]: getDefaultAIAgentData(),
    [KEYS.CONTINUE_CHAT_DATA]: null,
    [KEYS.POWER_RECYCLE_PERMISSION]: {},
    [KEYS.IS_SHOW_COVER]: false,
    [KEYS.IS_SHOW_CARD_LIKE_NEWGUID]: false,
    [KEYS.MATERIAL_POS_DATA]: {enable: false},
    [KEYS.DROP_MENU_TOOL_LIST]: [],
    [KEYS.DOC_WORD_NUM]: null,
    [KEYS.SDK_SHOW_SIDEBAR_TOOLS]: false,
    [KEYS.SDK_SHOW_DOCUMENT_TITLE]: true,
    [KEYS.SDK_SHOW_AI_PANEL]: true,
    [KEYS.IS_EDITOR_RELOADING]: false,
    [KEYS.SHOW_POWER_SETTING]: false,
    [KEYS.SHOW_MEMBER_LIST]: false,
    [KEYS.POWER_MODAL]: {docGuid: '', moreEntry: false},
    [KEYS.IS_TREE_BATCH_OPERATE]: false,
    [KEYS.TREE_SELECTED_OBJ]: {
        selectedCount: 0,
        checkedKeys: [],
        halfCheckedKeys: [],
        filterCheckedKeys: [],
    },
    [KEYS.TREE_SELECTED_FULL]: false,
    [KEYS.IS_SHOW_SIDEBAR]: true,
    [KEYS.FLEX_BUILDER_STATE]: {},
};
